import { useState, useRef, useEffect } from 'react';
import '../styles/DropZone.css';

export default function DropZone({ onFiles }) {
  const [dragging, setDragging] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    const handlePaste = (e) => {
      const items = Array.from(e.clipboardData?.items || []);
      const files = items
        .filter((item) => item.kind === 'file' && item.type.startsWith('image/'))
        .map((item) => {
          const file = item.getAsFile();
          if (!file) return null;
          const ext = file.type.split('/')[1] || 'png';
          const name = `pasted-image-${Date.now()}-${Math.random().toString(36).slice(2, 6)}.${ext}`;
          return new File([file], name, { type: file.type });
        })
        .filter(Boolean);
      if (files.length) onFiles(files);
    };
    document.addEventListener('paste', handlePaste);
    return () => document.removeEventListener('paste', handlePaste);
  }, [onFiles]);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const ALLOWED_TYPES = new Set([
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ]);
    const files = Array.from(e.dataTransfer.files).filter((f) =>
      f.type.startsWith('image/') || ALLOWED_TYPES.has(f.type)
    );
    if (files.length) onFiles(files);
  };

  const handleChange = (e) => {
    onFiles(Array.from(e.target.files));
    e.target.value = '';
  };

  return (
    <div
      className={`dropzone ${dragging ? 'dropzone--active' : ''}`}
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={handleDrop}
      onClick={() => inputRef.current.click()}
    >
      <span className="dropzone-icon">📎</span>
      <span className="dropzone-text">
        {dragging ? 'Drop files here' : 'Drag & drop, paste, or click to browse'}
      </span>
      <span className="dropzone-hint">Images, PDFs, Word, Excel, and PowerPoint accepted</span>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
        onChange={handleChange}
        className="file-input-hidden"
      />
    </div>
  );
}
